// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style_root__1k84G .style_icon__Cl1Cx {\n  width: 30px;\n  height: auto;\n  margin-right: 17px; }\n", ""]);
// Exports
exports.locals = {
	"root": "style_root__1k84G",
	"icon": "style_icon__Cl1Cx"
};
module.exports = exports;
